import { Base } from './base';

export class Order extends Base {
  id: string;
  wfstate: string;
  created: string;
  payment_status: string;
  payment_redirect_url: string;
}



// WEBPACK FOOTER //
// ./src/app/Models/order.ts